export class FetchUserPaymentMethodsAction {
  static readonly type = '[Payment] Fetch User Payment Methods';

  constructor(public userId: string) {}
}
